import { useEffect, useState } from "react";
import { getExtensionHealth, type ExtensionHealth as Health } from "./api";

export function ExtensionHealth({ id, global = false }: { id: string; global?: boolean }) {
  const [value, setValue] = useState<Health>();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!id) return;
    let active = true;
    const load = () => getExtensionHealth(id, global).then(result => { if (active) { setValue(result); setFailed(false); } }).catch(() => { if (active) setFailed(true); });
    void load(); const timer = window.setInterval(() => { if (!document.hidden) void load(); }, 30000);
    return () => { active = false; window.clearInterval(timer); };
  }, [id, global]);
  if (!id) return null;
  return <section className="extension-health" aria-label="Extension-Status"><strong>Installierte Extensions</strong>
    {failed ? <p>Extension-Status konnte nicht aktualisiert werden.</p> : !value ? <p>Status wird geladen …</p> : <>
      {!value.online && <p>Gerät offline oder noch nicht gemeldet · angezeigte Zustände sind der letzte bekannte Stand.</p>}
      {!value.extensions.length && <p>Noch keine installierten Extensions gemeldet.</p>}
      <ul>{value.extensions.map(extension => {
        const problem = ["error", "critical", "fatal"].includes(extension.level ?? "") || ["failed", "error", "crashed"].includes(extension.state);
        const running = extension.enabled && ["running", "healthy", "active"].includes(extension.state);
        const warning = extension.level === "warning";
        const text = problem ? "Problem gemeldet" : warning ? "Warnung gemeldet" : !extension.enabled ? "Deaktiviert" : running ? "Läuft · kein Fehler gemeldet" : ({ stopped: "Gestoppt", starting: "Startet", installing: "Wird installiert", pending: "Wartet", stopping: "Wird gestoppt" } as Record<string,string>)[extension.state] ?? "Zustand noch nicht bestätigt";
        return <li key={extension.id}><span className={`state-badge ${!value.online ? "neutral" : problem || warning ? "warning" : running ? "online" : "neutral"}`}><i />{extension.name}: {text}</span><small>{extension.installed_version ? `Version ${extension.installed_version} · ` : ""}Stand {new Date(extension.reported_at).toLocaleString()}</small></li>;
      })}</ul>
    </>}
  </section>;
}
